import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { Col, Container, Icon, Row } from '@pinpoint/design-kit';

import { Button } from 'src/components';
import { modelViewActions } from 'src/store/actions';
import { Page } from 'src/containers';
import { ROUTES } from 'src/config';
import { currentTenantSelector, modelSelector, siteRoleSelector } from 'src/store/selectors';
import Fairness from '../../components/models/charts/fairness';

function ModelsFairness() {
  const { modelId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const tenant = useSelector(currentTenantSelector);
  const siteRole = useSelector(siteRoleSelector);
  const model = useSelector(modelSelector);

  // When the tenant or the model id changes, retrieve the model anew
  useEffect(() => {
    dispatch(modelViewActions.fetchModel(modelId));
  }, [tenant, modelId, dispatch]);

  useEffect(
    () => () => {
      dispatch(modelViewActions.resetPage());
    },
    [modelId, dispatch]
  );

  return (
    <Container
      w="100%"
      minW="100%"
      h="100%"
      minH="100%"
      data-debug="container"
      d="flex"
      flexDir="column"
      overflow="hidden"
    >
      <Row data-debug="nav-row" p={{ t: '1.5rem' }} m={{ x: '.5rem' }}>
        <Col gutterWidth="0" d="inline-flex" size="12" align="center">
          <Button
            buttonStyle="primary"
            onClick={() => {
              history.push(ROUTES.MODELS);
            }}
          >
            <Icon name="LongLeft" color="white" m={{ r: '0.5rem' }} size="1rem" />
            BACK
          </Button>
        </Col>
      </Row>
      <Row data-debug="content" p={{ t: '.5rem' }} m={{ x: '.5rem' }} h="100%" justify="stretch" align="stretch">
        <Fairness model={model} siteRole={siteRole} />
      </Row>
    </Container>
  );
}

ModelsFairness.propTypes = {};

export default Page(ModelsFairness);
